import { type ReactNode, useEffect, useId, useRef } from 'react';
import { Icon } from './Icon';

function useEscape(onClose: () => void) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
}

/** Боковая панель справа: карточка сотрудника. */
export function Drawer({
  title,
  subtitle,
  header,
  onClose,
  children,
}: {
  title: string;
  subtitle?: string | null;
  header?: ReactNode;
  onClose: () => void;
  children: ReactNode;
}) {
  useEscape(onClose);
  const titleId = useId();
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => closeRef.current?.focus(), []);
  return (
    <div className="layer" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <button type="button" className="layer-scrim" aria-label="Закрыть" onClick={onClose} />
      <div className="drawer">
        <div className="drawer-head">
          <div style={{ display: 'flex', gap: 14, alignItems: 'center', minWidth: 0 }}>
            {header}
            <div style={{ minWidth: 0 }}>
              <h2 id={titleId}>{title}</h2>
              {subtitle ? <p className="person-meta">{subtitle}</p> : null}
            </div>
          </div>
          <button ref={closeRef} type="button" className="btn-icon" aria-label="Закрыть" onClick={onClose}>
            <Icon name="x" />
          </button>
        </div>
        <div className="drawer-body">{children}</div>
      </div>
    </div>
  );
}

/** Окно по центру: «Что мне можно». */
export function Modal({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  useEscape(onClose);
  const titleId = useId();
  return (
    <div className="layer center" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <button type="button" className="layer-scrim" aria-label="Закрыть" onClick={onClose} />
      <div className="modal">
        <div className="modal-head">
          <h2 id={titleId}>{title}</h2>
          <button type="button" className="btn-icon" aria-label="Закрыть" onClick={onClose}>
            <Icon name="x" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
